import { css } from "styled-components";

export const defaultSizeStyle = css`
  height: 40px;
  padding: 0 var(--gap-4);
  gap: var(--gap-2);
  font-size: var(--font-size-small);
  line-height: var(--line-height-small);

  svg {
    height: 18px;
    width: auto;
  }
`;
